// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e151e7cf","977":"5ca7fd75"}[chunkId] + ".chunk.js";
};